import { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
  title: string;
}

export function Layout({ children, title }: LayoutProps) {
  return <div className="w-full px-0 2xl:px-6 pt-0 2xl:pt-6">{children}</div>;
}
// <h1 className="text-2xl font-bold mb-6">{title}</h1>
// <div className="bg-white p-6 rounded-lg shadow">
//   {children}
// </div>
